import React, {useEffect, useState} from 'react';
import {useDispatch} from "react-redux";

import styles from './RegistrationPageCleaner.module.scss';
import RegistrationPageCleanerStep1 from "../RegistrationPageCleanerStep1/RegistrationPageCleanerStep1";
import RegistrationPageCleanerStep2 from "../RegistrationPageCleanerStep2/RegistrationPageCleanerStep2";
import RegistrationPageCleanerStep3 from "../RegistrationPageCleanerStep3/RegistrationPageCleanerStep3";
import {registrationCleanerActions} from "../../../../store/slices/registrationCleanerSlice";

const RegistrationPageCleaner = ({setIsCleaner}) => {
    const [currentStep, setCurrentStep] = useState(1);

    const dispatch = useDispatch();

    useEffect(() => {
        const handleBeforeUnload = () => {
            dispatch(registrationCleanerActions.setProfilePhoto(null));
            dispatch(registrationCleanerActions.setPassportPhotos([]));
        };

        dispatch(registrationCleanerActions.clearAllData());
        window.addEventListener('load', handleBeforeUnload);

        return () => {
            window.removeEventListener('load', handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        dispatch(registrationCleanerActions.setProfilePhoto(null));
        dispatch(registrationCleanerActions.setPassportPhotos([]));
    }, []);

    return (
        <>
            {
                currentStep === 1 &&
                <RegistrationPageCleanerStep1
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                />
            }
            {
                currentStep === 2 &&
                <RegistrationPageCleanerStep2
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                />
            }
            {
                currentStep === 3 &&
                <RegistrationPageCleanerStep3
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    setIsCleaner={setIsCleaner}
                />
            }
        </>
    );
};

export default RegistrationPageCleaner;
